<template>
    <div class="max-w-5xl mx-auto bg-white overflow-hidden shadow-xl  pt-2 py-6 px-12">
        <div class="relative" v-if="addMenu">
            <slot name="menu"></slot>
        </div>
        <div class="mt-5">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        icon: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        align: {
            type: String,
            default: 'left',
        },
        addMenu: {
            type: Boolean,
            default: false
        },
    }
}
</script>
